// extracted by mini-css-extract-plugin
module.exports = {"altHero":"_f","altProd":"ag","subheading":"bg","subtext":"cg","extrainfo":"dg","copy":"eg","cta":"fg","disabled":"gg"};